import React, { createContext, useContext, useState } from 'react';

const Context = createContext(null);

export const useCategoryGroup = () => {
    const context = useContext(Context);
    
    if (context === 'undefined') {
        throw new Error('Hook [useCategoryGroup] must be inside [CategoryGroupProvider].');
    }
    
    return context;
};

export const CategoryGroupProvider = ({ children }) => {
    const [categoryGroup, setCategoryGroup] = useState(null);
    
    return (
        <Context.Provider value={[categoryGroup, setCategoryGroup]}>
            {children}
        </Context.Provider>
    );
};
